import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { BrandType } from 'types/brand'
import styles from 'styles/components/list.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import classNames from 'classnames'
import { StoreType } from 'types/store'

type Props = {
  brandList: BrandType[]
  stores: StoreType[]
}

const BrandList: FC<Props> = (props) => {
  const { brandList, stores } = props
  const dispatch = useDispatch()

  return (
    <ul className={styles.brand__list}>
      {brandList.map((brand) => (
        <li
          key={brand.brand_ref?.id}
          className={styles.brand__inner}
          onClick={() => dispatch(push(`/admin/brand/${brand.brand_ref?.id}`))}
        >
          <div className={styles.brand__label}>
            <p className={classNames(text.font_bold, text.font_mediumLarge)}>{brand.name}</p>
            <Spacer size={8} />
            <p className={styles.brand_items}>
              {brand.store_refs
                .map((storeRef) => {
                  const brandStore = stores.find((store) => store.store_id === storeRef.id)
                  return brandStore ? brandStore.name : null
                })
                .join(', ')}
            </p>
          </div>
        </li>
      ))}
    </ul>
  )
}

export default BrandList
